export type PracticeLabSelection =
  | { type: "practice"; id: string }
  | { type: "lab"; id: string };

export function encodePracticeLabSelection(
  selection: PracticeLabSelection
): string {
  return `${selection.type}:${selection.id}`;
}

export function decodePracticeLabSelection(
  value: string | null
): PracticeLabSelection | null {
  if (!value) return null;
  const separatorIndex = value.indexOf(":");
  if (separatorIndex < 1) return null;
  const type = value.slice(0, separatorIndex);
  const id = value.slice(separatorIndex + 1);
  if (!id || (type !== "practice" && type !== "lab")) return null;
  return { type, id };
}

export function selectedPracticeLabValue(
  practiceId?: string | null,
  labId?: string | null
): string | null {
  if (labId) return encodePracticeLabSelection({ type: "lab", id: labId });
  if (practiceId) {
    return encodePracticeLabSelection({ type: "practice", id: practiceId });
  }
  return null;
}
